import type { View } from 'product-list/types/View'

export type ProductListState = {
	slotId: string
	count: number
	view: View
}

const getProductListStateStorageKey = (name: string) => `product-list-${name}`

export const getProductListState = (
	name: string
): ProductListState | undefined => {
	const key = getProductListStateStorageKey(name)
	const state = sessionStorage.getItem(key)
	if (!state) {
		return undefined
	}
	return JSON.parse(state) as ProductListState
}

export function storeProductListState(name: string, state: ProductListState) {
	const key = getProductListStateStorageKey(name)
	sessionStorage.setItem(key, JSON.stringify(state))
}

export function clearProductListState(name: string) {
	const key = getProductListStateStorageKey(name)
	sessionStorage.removeItem(key)
}
